import { app } from '../../app.module'
app
  // カテゴリ管理モーダルを表示するためのボタン
  .directive('editCategoryButton', () => {
    return {
      restrict: 'E',
      template: require('./edit-category-button.pug')(),
      controller: function ($rootScope, $scope, $mdDialog, $attrs) {
        // ボタンをクリックした際の処理
        $scope.showCategoryModal = function () {
          // モーダル用のスコープを新規に作成し、モーダル内で使用するパラメーターを格納
          const modalScope: { categoryId: number } = $rootScope.$new()

          // カテゴリID
          modalScope.categoryId = $attrs.categoryId

          // モーダルを表示する
          $mdDialog.show({
            template: require('./edit-category-modal.pug')(),
            scope: modalScope,
            clickOutsideToClose: true,
          })
        }
      },
    }
  })
